module.exports = __webpack_public_path__ + "img/wfzs.f38e075.png";